import { render } from "./QuiSommesNousPages.vue?vue&type=template&id=3bea16e3"
import script from "./QuiSommesNousPages.vue?vue&type=script&lang=js"
export * from "./QuiSommesNousPages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__